import { api } from "../../api"
import { ApiException } from "../../api-exception";

export interface ILoginBody{
  codFunc: number;
  codCliente: number;
  mD5_SENHA: string;
}

export const GerarToken = async(body: ILoginBody): Promise<string> => {
    try {
        const { data } = await api.post(`/gerar-token/${body.codCliente}`, body);

        return data;
    } 
    catch (error) {
        throw new ApiException(
            error,
            "Não foi possível efetuar o login!"
        );
    }
}